import {
    GETMULTIPLEMAPPINGLISTFORPARTNER_SUCCESS,
    GETMULTIPLEMAPPINGLISTFORPARTNER_FAILED,
    RESET_GETMULTIPLEMAPPINGLISTFORPARTNER,
    LOADING_GETMULTIPLEMAPPINGLISTFORPARTNER,
    NETWORK_ERROR_GETMULTIPLEMAPPINGLISTFORPARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMULTIPLEMAPPINGLISTFORPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMULTIPLEMAPPINGLISTFORPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMULTIPLEMAPPINGLISTFORPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMULTIPLEMAPPINGLISTFORPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMULTIPLEMAPPINGLISTFORPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};